// Mock data for Mouldsurv Ltd website

export const companyInfo = {
  name: "Mouldsurv Ltd",
  tagline: "Expert Mould & Damp Solutions Across the UK",
  address: "Suite 1A, Unit 5 Wickham Business Park, Honywood Road, Basildon, Essex, SS14 3EQ",
  email: "enquiries@oxford-ec.co.uk",
  phone: "03456 868 868",
  website: "www.mouldsurv.co.uk",
  serviceAreas: ["Essex", "London", "Kent", "East Anglia", "South East England"],
  socialMedia: {
    facebook: "https://www.facebook.com/mouldsurvgroup",
    instagram: "https://www.instagram.com/mouldsurvgroup",
    linkedin: "https://www.linkedin.com/company/mouldsurv-group"
  }
};

export const certifications = [
  {
    id: "federation-of-damp",
    name: "Federation Of Damp",
    image: "https://customer-assets.emergentagent.com/job_mouldsurv-essex/artifacts/hwm0ni5q_logo-trans.png",
    alt: "Federation Of Damp Member",
    heightClass: "h-28 md:h-32",
    width: 200,
    height: 128
  },
  {
    id: "iso-9001",
    name: "ISO 9001",
    image: "/certs/iso-9001-isoqar-ukas.png",
    alt: "ISO 9001 Certified - ISOQAR UKAS Management Systems",
    heightClass: "h-24 md:h-28",
    width: 179,
    height: 112
  },
  {
    id: "ssip",
    name: "SSIP",
    image: "/certs/ssip-seal.png",
    alt: "Assessed by a SSIP Member Scheme",
    heightClass: "h-28 md:h-32",
    width: 128,
    height: 128
  },
  {
    id: "smas-worksafe",
    name: "SMAS Worksafe",
    image: "/certs/smas-worksafe.png",
    alt: "SMAS Worksafe Accredited",
    heightClass: "h-12 md:h-16",
    width: 188,
    height: 64
  }
];

export const pricing = [
  {
    type: "Domestic",
    title: "Mould Inspection",
    price: "£155",
    description: "Standard inspection for residential properties",
    features: [
      "Visual inspection",
      "Moisture readings",
      "Photographic evidence",
      "Detailed report"
    ]
  },
  {
    type: "Domestic",
    title: "Damp Survey",
    price: "£235",
    description: "Comprehensive damp assessment",
    features: [
      "Full property survey",
      "Thermal imaging",
      "HHSRS assessment",
      "Remediation plan"
    ]
  },
  {
    type: "Commercial",
    title: "Commercial Assessment",
    price: "£420",
    description: "Tailored for commercial properties",
    features: [
      "Multi-area inspection",
      "Risk assessment",
      "Compliance reporting",
      "Ongoing support"
    ]
  }
];

// Empty blog posts - will be populated via RankPill webhook
export const blogPosts = [];

export const services = [
  {
    id: "mould-inspections",
    title: "Mould Inspections",
    slug: "mould-inspections",
    shortDescription: "Comprehensive mould detection and analysis to identify the source and extent of mould growth in your property.",
    description: "Our comprehensive mould inspection service uses advanced diagnostic equipment to identify and assess all types of mould growth in your property. We provide detailed reports and actionable recommendations.",
    icon: "Search",
    image: "https://images.pexels.com/photos/4290722/pexels-photo-4290722.jpeg",
    price: "£155",
    features: [
      "Visual inspection of all accessible areas",
      "Thermal imaging to detect hidden moisture",
      "Air and surface sampling",
      "Detailed laboratory analysis",
      "Comprehensive written report with recommendations",
      "HHSRS compliant assessment",
      "Follow-up consultation included"
    ]
  },
  {
    id: "damp-surveys",
    title: "Damp Surveys",
    slug: "damp-surveys",
    shortDescription: "Professional damp surveys using advanced diagnostic equipment to identify and assess moisture problems.",
    description: "Expert damp surveys to identify the source and extent of moisture problems in your property. We use state-of-the-art equipment and provide HHSRS compliant reports.",
    icon: "Droplets",
    image: "https://images.unsplash.com/photo-1580157241136-8bc0249d9701",
    price: "£235",
    features: [
      "Moisture meter readings throughout property",
      "Thermal imaging surveys",
      "Identification of damp sources (rising, penetrating, condensation)",
      "HHSRS compliant assessments",
      "Detailed remediation recommendations",
      "Photographic evidence",
      "Expert consultation"
    ]
  },
  {
    id: "air-quality-testing",
    title: "Indoor Air Quality Testing",
    slug: "air-quality-testing",
    shortDescription: "Advanced air quality testing to measure mould spore levels and other contaminants affecting your indoor environment.",
    description: "Comprehensive indoor air quality testing to identify mould spores, VOCs, and other airborne contaminants that may be affecting your health and wellbeing.",
    icon: "Wind",
    image: "https://images.pexels.com/photos/8293642/pexels-photo-8293642.jpeg",
    price: "£280",
    features: [
      "Spore trap air sampling",
      "VOC (Volatile Organic Compounds) testing",
      "Humidity and temperature monitoring",
      "Laboratory analysis by certified labs",
      "Health risk assessment",
      "Detailed findings report",
      "Improvement recommendations"
    ]
  },
  {
    id: "remediation",
    title: "Mould Remediation",
    slug: "remediation",
    shortDescription: "Professional mould removal and remediation services following industry best practices and safety protocols.",
    description: "Safe and effective mould removal by trained specialists using industry-leading techniques and equipment to restore your property to a healthy state.",
    icon: "ShieldCheck",
    image: "https://images.pexels.com/photos/7937744/pexels-photo-7937744.jpeg",
    price: "From £520",
    features: [
      "Containment of affected areas",
      "HEPA filtration and air scrubbing",
      "Safe mould removal",
      "Anti-microbial treatment",
      "Disposal of contaminated materials",
      "Post-remediation verification testing",
      "12-month warranty on work completed"
    ]
  },
  {
    id: "prevention",
    title: "Mould Prevention Services",
    slug: "prevention",
    shortDescription: "Proactive solutions and expert guidance to prevent mould growth and maintain a healthy indoor environment.",
    description: "Prevention is better than cure. Our mould prevention service helps you maintain a mould-free property through expert advice, monitoring, and proactive solutions.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1628624747186-a941c476b7ef",
    price: "From £185",
    features: [
      "Property ventilation assessment",
      "Humidity monitoring solutions",
      "Anti-condensation advice",
      "Preventive treatment application",
      "Maintenance recommendations",
      "Educational materials for occupants",
      "Annual follow-up inspection"
    ]
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Initial Contact",
    description: "Reach out via phone, email, or our online form. We'll discuss your concerns and schedule an appointment within 48 hours."
  },
  {
    step: 2,
    title: "Professional Inspection",
    description: "Our certified specialists conduct a thorough inspection using advanced diagnostic equipment including thermal imaging cameras."
  },
  {
    step: 3,
    title: "Detailed Report",
    description: "Within 48 hours, receive a comprehensive HHSRS-compliant report with photographic evidence, findings, and clear recommendations."
  },
  {
    step: 4,
    title: "Expert Consultation",
    description: "We discuss the findings with you, answer questions, and explain the recommended remediation or prevention strategies."
  },
  {
    step: 5,
    title: "Implementation",
    description: "If required, our team carries out remediation work using industry best practices, with minimal disruption to your property."
  },
  {
    step: 6,
    title: "Verification & Follow-up",
    description: "Post-work testing ensures the problem is resolved. We provide ongoing support and preventive advice."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kim Cartwright",
    role: "Compliance Manager, Essex",
    content: "Exceptional service from start to finish. Their detailed HHSRS reports have been invaluable for our commercial properties. Highly professional team who really know their stuff.",
    rating: 5
  },
  {
    id: 2,
    name: "Steph Tayler",
    role: "PPM Transformation Manager, Essex",
    content: "After struggling with damp issues for years, Mouldsurv identified the root cause within hours using thermal imaging. The remediation work was completed quickly and professionally.",
    rating: 5
  },
  {
    id: 3,
    name: "Dean Berton",
    role: "Benchmark Analyst, Essex",
    content: "I've used Mouldsurv for multiple commercial properties. Their understanding of UK legislation and commitment to compliance gives me complete peace of mind. Wouldn't use anyone else.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is the Homes (Fitness for Human Habitation) Act 2018?",
    answer: "This Act requires landlords to ensure their rental properties are fit for human habitation at the start of the tenancy and throughout. Damp and mould are specifically listed as hazards under the Act. Tenants can take legal action if their landlord fails to address these issues."
  },
  {
    id: 2,
    question: "How does HHSRS relate to damp and mould?",
    answer: "The Housing Health and Safety Rating System (HHSRS) is used by local authorities to assess potential risks and hazards in residential properties. Damp and mould growth are Category 1 hazards that can result in enforcement action against landlords if not properly addressed."
  },
  {
    id: 3,
    question: "How quickly can you attend a property?",
    answer: "We typically offer appointments within 48-72 hours for standard inspections. For urgent cases or where tenant health is at risk, we can often attend within 24 hours across Essex, London, and Kent."
  },
  {
    id: 4,
    question: "Do you provide reports for insurance claims?",
    answer: "Yes, our comprehensive reports include photographic evidence, moisture readings, and detailed analysis suitable for insurance claims, legal proceedings, or property transactions."
  },
  {
    id: 5,
    question: "What causes mould growth in properties?",
    answer: "Mould requires moisture to grow. Common causes include condensation from poor ventilation, leaking pipes, rising damp, penetrating damp from building defects, and inadequate heating. Our surveys identify the specific source affecting your property."
  },
  {
    id: 6,
    question: "Is mould dangerous to health?",
    answer: "Yes, mould can cause respiratory problems, allergies, asthma, and other health issues, particularly in vulnerable individuals such as children, elderly people, and those with existing respiratory conditions. Professional removal is recommended."
  },
  {
    id: 7,
    question: "How long does a mould inspection take?",
    answer: "A typical residential inspection takes 1-3 hours depending on property size and complexity. Commercial properties may require longer. You'll receive a comprehensive written report within 48 hours."
  },
  {
    id: 8,
    question: "Can I claim back the cost from my landlord?",
    answer: "If you're a tenant and the mould is due to landlord negligence or building defects, you may be entitled to reimbursement. Our reports provide the evidence needed to support such claims."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.pexels.com/photos/4290722/pexels-photo-4290722.jpeg",
    title: "Professional Mould Inspection",
    category: "inspection"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/7937744/pexels-photo-7937744.jpeg",
    title: "Remediation in Progress",
    category: "remediation"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/8293642/pexels-photo-8293642.jpeg",
    title: "Air Quality Testing",
    category: "testing"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1580157241136-8bc0249d9701",
    title: "Damp Survey Assessment",
    category: "survey"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/8292785/pexels-photo-8292785.jpeg",
    title: "Moisture Detection",
    category: "inspection"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1628624747186-a941c476b7ef",
    title: "Clean Healthy Interior",
    category: "prevention"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1676630656246-3047520adfdf",
    title: "Thermal Imaging Survey",
    category: "survey"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/6195951/pexels-photo-6195951.jpeg",
    title: "Professional Equipment",
    category: "equipment"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1621363183028-c97aec91a9f3",
    title: "Property Inspection",
    category: "inspection"
  }
];

export const legislation = [
  {
    id: 1,
    title: "Homes (Fitness for Human Habitation) Act 2018",
    description: "Requires landlords to ensure rental properties are fit for human habitation. Tenants can take action if properties have serious damp and mould issues.",
    effectiveDate: "March 20, 2019",
    relevance: "high"
  },
  {
    id: 2,
    title: "Housing Health and Safety Rating System (HHSRS)",
    description: "Risk-based evaluation tool to help local authorities identify and protect against potential hazards in residential properties. Damp and mould are Category 1 hazards.",
    effectiveDate: "April 6, 2006",
    relevance: "high"
  },
  {
    id: 3,
    title: "Understanding and Addressing Damp and Mould (2023)",
    description: "Government guidance for social housing providers on how to identify, prevent and address damp and mould issues in their properties.",
    effectiveDate: "February 2023",
    relevance: "medium"
  },
  {
    id: 4,
    title: "Landlord and Tenant Act 1985",
    description: "Sets out the responsibilities of landlords to maintain the structure and exterior of rental properties, including keeping them free from damp.",
    effectiveDate: "September 16, 1985",
    relevance: "medium"
  }
];
